export default __webpack_public_path__ + "static/media/me.24c2de4a.jpg";